module.exports = __webpack_public_path__ + "img/wk-product-3-2x.cdb67178.png";